import React, { useState, useContext, useEffect } from 'react';
import useObtenerRelacionClub from '../../Hooks/useObtenerRelacionClub';
import CallbackList from '../../Components/Common/Modules/CallbackList';
import Title from '../../Components/Common/Atoms/Title';
import Toast from '../../Components/Common/Modules/Toast';
import Breadcrumb from '../../Components/Common/Modules/Breadcrumb';
import DesvincularService from '../../Services/DesvincularService';
import SessionHandler from '../../Handlers/Session';
import Metering from '../../Handlers/Metering';
import { CookieContext } from '../../Contexts/CookieContext';
import ErrorBoundary from '../../Components/Common/Organism/ErrorBoundary';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import Hotjar from '../../Handlers/Hotjar';
import Analytics from '../../Helpers/Analytics';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router';
import TitleWeb from '../../Components/Common/Web/Title';
import PathsConfig from '../../Config/RoutePaths';
import Datadog from '../../Helpers/Datadog';
import { CustomEventsDatadog, CustomEventsErrorDatadog } from '../../Config/Datadog';

const DesvincularCredencial = (props) => {
    const history = useHistory();
    const [updateCookie, setUpdateCookie] = useContext(CookieContext);
    const [data, error, isLoading] = useObtenerRelacionClub();
    const [respuesta, setRespuesta] = useState('');
    const [isLoadingDesvincular, setIsLoadingDesvincular] = useState(false);
    useEffect(() => {
        Hotjar.HotjarTrigger('LN.MiCuenta.Desvinculacion.MensajeAccesoDigital');
    });

    let usuarioEmail = Cookies.get('usuarioemail');

    const obtenerLinkActivar = () => {
        return `${
            process.env.REACT_APP_SUSCRIPCIONES
        }suscripcion/A/1/?callback=${window.btoa(
            location.href
        )}&fc=176&productCategory=Voluntario`;
    };

    const handleClickButtonDesvincular = async (e) => {
        if (data.response.desasociarHabilitado) {
            await desasociar('Desvincular');
        } else {
            setRespuesta('');
        }
    };

    const redirectAMiClub = (response) => {
        history.push({
            pathname: PathsConfig.MiClub,
            state: {
                respuesta: response,
            },
        });
    };

    const handleClickButtonObtBeneficios = () => {
        location.href = obtenerLinkActivar();
    };

    const handleClickButtonMantBeneficios = () => {
        redirectAMiClub();
    };

    const desasociar = async () => {
        setIsLoadingDesvincular(true);
        await DesvincularService()
            .then((res) => {
                if (res.code == '0000') {
                    Datadog.trackCustomEvent(
                        CustomEventsDatadog.desvincularCredencial
                    );
                    Analytics.trackClick(
                        null,
                        'Quiero Desasociar',
                        'Desasociar Acceso Digital Bonificado',
                        { Usuario: usuarioEmail }
                    );
                    Cookies.remove('ProductoPremiumId');
                    SessionHandler.Reload()
                        .then(() => Metering.obtenerCookieSuscriptor())
                        .then(() => {
                            setIsLoadingDesvincular(false);
                            setUpdateCookie(true);
                            redirectAMiClub('Desvincular');
                        });
                } else {
                    setRespuesta('');
                    Datadog.trackCustomEventWarning(CustomEventsErrorDatadog.errorDesvincularCredencial);
                }
            })
            .catch((error) => {
                console.log(error);
                setRespuesta('');
                setIsLoadingDesvincular(false);
            });
    };

    const tieneCredencial = (data) => {
        return data && data.response == null && data.code == '4010';
    };

    const puedeDesvincularNormal = (data) => {
        return (
            data &&
            data.response &&
            data.response.tieneClub &&
            data.response.desasociarHabilitado &&
            !data.response.tieneBonificado
        );
    };

    const puedeDesvincularBonificado = (data) => {
        return (
            data &&
            data.response &&
            data.response.tieneClub &&
            data.response.desasociarHabilitado &&
            data.response.tieneBonificado
        );
    };

    return (
        <>
            <Breadcrumb
                firstItem="Club LA NACION"
                href={PathsConfig.MiClubVincular}
                text="Vincular credencial"
            />

            <TitleWeb text="Desvincular credencial" />

            <div className="container-streched">
                {/*Pantalla de carga*/}
                <LoadingSpinner isLoading={isLoading || isLoadingDesvincular}>
                    <ErrorBoundary error={error}>
                        {/*Pantalla error*/}
                        {/*Pantalla sin credencial*/}
                        {tieneCredencial(data) && (
                            <Toast status="alert" title={data.message}>
                                No se posee credencial vinculada.
                            </Toast>
                        )}

                        {/*Pantalla desvinculacion bonificado*/}
                        {puedeDesvincularBonificado(data) && respuesta == '' && (
                            <>
                                <Toast
                                    title="Estás por desvincular una tarjeta y perderás estos beneficios"
                                    status="alert"
                                />

                                <Title size="--s --arial --font-bold">
                                    Beneficios de credencial Club LA NACION{' '}
                                    {data.response.categoria}:{' '}
                                </Title>

                                <CallbackList
                                    title="Acceso Digital"
                                    description="En caso de querer vincular la tarjeta a otra cuenta deben pasar 48hs hábiles para volver a tener Acceso Digital."
                                    listText={[
                                        'Acceso ilimitado a LA NACION',
                                        'Acceso a Edición impresa en PDF',
                                    ]}
                                    href1="#"
                                    href2="#"
                                    modButton1="--primary --block-mobile"
                                    modButton2="--secondary --block-mobile"
                                    textButton1="Desvincular"
                                    textButton2="Mantener beneficios"
                                    onClick1stButton={
                                        handleClickButtonDesvincular
                                    }
                                    onClick2ndButton={
                                        handleClickButtonMantBeneficios
                                    }
                                />
                            </>
                        )}

                        {/*Pantalla desvinculacion normal*/}
                        {puedeDesvincularNormal(data) && respuesta == '' && (
                            <>
                                <Toast
                                    title="¿Deseas desvincular tu tarjeta?"
                                    status="alert"
                                />

                                <Title size="--s">
                                    Si sos Black(Titular o Adicional) o Premium
                                    Titular, podés tener:{' '}
                                </Title>

                                <CallbackList
                                    title="Acceso Digital"
                                    description="En caso de querer vincular la tarjeta a otra cuenta deben pasar 48hs hábiles para volver a tener Acceso Digital."
                                    listText={[
                                        'Acceso ilimitado a LA NACION',
                                        'Acceso a Edición impresa en PDF',
                                    ]}
                                    href1="#"
                                    href2="#"
                                    modButton1="--primary --block-mobile"
                                    modButton2="--secondary --block-mobile"
                                    textButton1="Desvincular"
                                    textButton2="Obtener beneficios"
                                    onClick1stButton={
                                        handleClickButtonDesvincular
                                    }
                                    onClick2ndButton={
                                        handleClickButtonObtBeneficios
                                    }
                                />
                            </>
                        )}
                    </ErrorBoundary>
                </LoadingSpinner>
            </div>
        </>
    );
};

export default DesvincularCredencial;
